
import { useState } from 'react';
import { useToast } from '@/hooks/use-toast';

interface UseFormNavigationProps {
  validateStep: (step: number) => boolean;
  totalSteps: number;
}

export const useFormNavigation = ({ validateStep, totalSteps }: UseFormNavigationProps) => {
  const [step, setStep] = useState(1);
  const { toast } = useToast();

  const handleNext = () => {
    if (validateStep(step)) {
      setStep(prev => Math.min(prev + 1, totalSteps));
    } else {
      toast({
        title: "Validation Error",
        description: "Please correct the errors before proceeding.",
        variant: "destructive"
      });
    }
  };

  const handleBack = () => {
    setStep(prev => Math.max(prev - 1, 1));
  };

  const goToStep = (stepNumber: number) => {
    if (stepNumber >= 1 && stepNumber <= totalSteps) {
      setStep(stepNumber);
    }
  };

  return {
    step,
    setStep,
    handleNext,
    handleBack,
    goToStep,
    isFirstStep: step === 1,
    isLastStep: step === totalSteps
  };
};
